"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var styled_component_helpers_1 = require("./styled-component-helpers");

var Image_1 = __importDefault(require("./Image"));

var Link_1 = __importDefault(require("./Link"));

var Typography_1 = require("./Typography");
/**
 * CarouselItem(s) should be placed inside the Carousel component
 * @param props
 * @returns {*}
 * @constructor
 */


var CarouselItem = function CarouselItem(props) {
  return React.createElement(exports.CarouselItemWrapper, {
    onClick: props.onClick,
    theme: props.theme
  }, props.children, props.description && React.createElement(Typography_1.Par.textBody, null, props.description), React.createElement(OpenSlide, null, React.createElement(Link_1["default"], {
    icon: React.createElement(Image_1["default"], {
      src: "plus_white_24x24.svg",
      alt: "Plus Icon"
    })
  }, "Details anzeigen")));
};

CarouselItem.defaultProps = {
  theme: styled_component_helpers_1.darkTheme
};
exports["default"] = CarouselItem;
var OpenSlide = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 20px;\n  left: ", "px;\n  z-index: 10;\n"], ["\n  position: absolute;\n  bottom: 20px;\n  left: ", "px;\n  z-index: 10;\n"])), styled_component_helpers_1.units.mobile.separator);
exports.CarouselItemWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  height: 300px;\n  background-color: ", ";\n  margin: 0 2px;\n  padding: ", "px;\n  overflow: hidden;\n"], ["\n  position: relative;\n  height: 300px;\n  background-color: ", ";\n  margin: 0 2px;\n  padding: ", "px;\n  overflow: hidden;\n"])), styled_component_helpers_1.theme('carousel.item.backgroundColor'), styled_component_helpers_1.units.mobile.separator);
var templateObject_1, templateObject_2;